export enum SimulationState {
	unknown,
	busy,
	success,
	error,
}
